import { isSameDay, parseISO, isSameMonth } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export function formatDate(startTime: string, endTime: string | undefined) {
	let ret: string

	if (endTime && isSameDay(parseISO(startTime), parseISO(endTime))) {
		ret =
			formatInTimeZone(
				parseISO(startTime),
				'Europe/Budapest',
				'yyyy. MM. dd. HH:mm'
			) +
			'-' +
			formatInTimeZone(parseISO(endTime), 'Europe/Budapest', 'HH:mm')
	} else if (endTime) {
		const t2 = parseISO(endTime!).getTime()
		const t1 = parseISO(startTime).getTime()
		const diffTime = Math.floor((t2 - t1) / (24 * 3600 * 1000))
		if (diffTime >= 2 && isSameMonth(parseISO(startTime), parseISO(endTime))) {
			ret =
				formatInTimeZone(
					parseISO(startTime),
					'Europe/Budapest',
					'yyyy. MM. dd'
				) +
				'-' +
				formatInTimeZone(parseISO(endTime), 'Europe/Budapest', 'dd.')
		} else if (diffTime >= 2) {
			ret =
				formatInTimeZone(
					parseISO(startTime),
					'Europe/Budapest',
					'yyyy. MM. dd'
				) +
				'-' +
				formatInTimeZone(parseISO(endTime), 'Europe/Budapest', 'yyyy. MM. dd.')
		} else {
			ret =
				formatInTimeZone(
					parseISO(startTime),
					'Europe/Budapest',
					'yyyy. MM. dd. HH:mm'
				) +
				'-' +
				formatInTimeZone(
					parseISO(endTime),
					'Europe/Budapest',
					'yyyy. MM. dd. HH:mm'
				)
		}
	} else if (startTime) {
		ret = formatInTimeZone(
			parseISO(startTime),
			'Europe/Budapest',
			'yyyy. MM. dd. HH:mm'
		)
	} else {
		ret = '-'
	}
	return ret
}
